import { getRangeValue, getTermValue } from '@/packages/JsonQuery';
import { EWCType } from '@/packages/api-models/common/json_query';

import { type ITagGroupConfig } from '../types';

export const wcCount: ITagGroupConfig = {
  get({ jsonQuery }) {
    const urbanBathroomType = getTermValue('wc_type')(jsonQuery) || EWCType.Any;
    const bathroomsCount = getRangeValue('wc')(jsonQuery);
    const bathroomsCountMin = (bathroomsCount && bathroomsCount.gte) || 0;
    const shouldShowTag = bathroomsCountMin > 1 || (urbanBathroomType === EWCType.Any && bathroomsCountMin === 1);

    if (!shouldShowTag) {
      return null;
    }

    return [
      {
        group: 'wcCount',
        text: `Санузлов минимум ${bathroomsCountMin}`,
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setBathroomCountMin',
      arguments: [null],
    });
  },
};
